import moment from "moment";
import pendingIcon from "../assets/images/pending.svg";
import acceptPendingIcon from "../assets/images/pending_state_active.svg";
import penIcon from "../assets/images/pen.svg";
import tradeAcceptedIcon from "../assets/images/accepted_state_active.svg";
import arrivalConfirmedIcon from "../assets/images/arrival_active.svg";
import pattiIcon from "../assets/images/patti_active.svg";
import { getCurrencyNumberWithOneDigit } from "./get-currency-number";
import paymentPending from "../assets/images/pay_pnd_Active.svg";
import paymentCompleted from "../assets/images/pay_com_active.svg";
import timer from "../assets/images/timer-img.png";
import hold from "../assets/images/hold.svg";
import reject from "../assets/images/reject.svg";
import tickmark from "../assets/images/verified.svg";
import approve from "../assets/images/approveTick.svg";
import blocked from "../assets/images/blocked.svg";
import disburse from "../assets/images/disbursed.svg";
import approved from "../assets/images/approvedTick.svg";
import acceptPend from "../assets/images/acceptance_pending.svg";
import tradeaccepted from "../assets/images/trade_accepted.svg";
import arlConf from "../assets/images/arl_conf.svg";
import pattiFinal from "../assets/images/patti_final.svg";
import pmtPend from "../assets/images/pmt_pend.svg";
import pmtCompl from "../assets/images/pmt_compl.svg";
import cancel_trade from "../assets/images/cance_trade.svg";
import closed from "../assets/images/trade_closed.svg";
import rejectExclamatory from "../assets/images/expired.svg";
import fullyPaid from "../assets/images/rePaid.svg";
import overDue from "../assets/images/overDueLoan.svg";
import close from "../assets/images/Cancelled.svg";
import exclamatory from "../assets/images/inactive.svg";
import reviewYellow from "../assets/images/reviewYellow.svg";
import loan_kyc_pend from "../assets/images/loan_kyc_pend.svg";

export function getText(partType) {
  return (
    partType.charAt(0).toUpperCase() + partType.toLowerCase().slice(1)
  ).replace("_", " ");
}
export function getPartnerType(item, trader) {
  let party = item;
  switch (item) {
    case "FARMER":
      if (trader) {
        party = "TRADER";
      } else {
        party = "Farmer";
      }
      break;
    case "BUYER":
      if (trader) {
        party = "TRADER";
      } else {
        party = item;
      }
      break;
    case "TRANSPORTER":
      party = item;
      break;
    case "Seller":
      if (trader) {
        party = "TRADER";
      } else {
        party = "Farmer";
      }
      break;
    case "LABOR":
      party = "COOLIE";
      break;
  }
  return getText(party);
}
export function getUnitVal(qSetting, cIndex) {
  var unit = qSetting[cIndex].qtyUnit;
  if (cIndex != -1) {
    if (qSetting[cIndex].qtyUnit.toLowerCase() == "kgs") {
      unit = "kgs";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "boxes") {
      unit = "Boxes";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "bags") {
      unit = "Bags";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "sacs") {
      unit = "Sacs";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "loads") {
      unit = "loads";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "pieces") {
      unit = "pieces";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "crates") {
      unit = "crates";
    }
  }
  return unit;
}

export function getQuantityUnit(qSetting, cIndex) {
  var unit = qSetting[cIndex].qtyUnit;
  if (cIndex != -1) {
    if (qSetting[cIndex].qtyUnit.toLowerCase() == "kgs") {
      unit = "kgs";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "boxes") {
      unit = "boxes";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "bags") {
      unit = "bags";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "sacs") {
      unit = "sacs";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "loads") {
      unit = "Loads";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "pieces") {
      unit = "pieces";
    } else if (qSetting[cIndex].qtyUnit.toLowerCase() == "crates") {
      unit = "crates";
    }
  }
  return unit;
}
export function colorAdjustBg(color, amount) {
  return (
    "#" +
    color
      .replace(/^#/, "")
      .replace(/../g, (color) =>
        (
          "0" +
          Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
        ).substr(-2),
      )
  );
}
export function getCropUnit(unit, qty) {
  const unitTypes = {
    CRATES: "C",
    BOXES: "Bx",
    BAGS: "Bg",
    SACS: "S",
    LOADS: "L",
    PIECES: "P",
  };
  const abbreviation = unitTypes[unit.toUpperCase()] || "";
  return qty ? qty.toFixed(1) + abbreviation : "";
}
export function formatInvLedger(array) {
  const items = array ? array : [];
  const formattedItems = items
    .map((item) => getCropUnit(item.unit, item.qty))
    .filter((cropUnit) => cropUnit !== "");
  return formattedItems.join(" | ");
}
export function getCurrencyNumberForWastage(number) {
  return number == null || number == 0 ? "" : number;
}
export function qtyValues(qty, qtyUnit, weight, wastage, rateType) {
  var unittype = rateType ? rateType : "KGS";
  const getCropUnit = (unit) => {
    var unitType = "";
    switch (unit.toLowerCase()) {
      case "crates":
        unitType = " C";
        break;
      case "boxes":
        unitType = " BX";
        break;
      case "bags":
        unitType = " BG";
        break;
      case "sacs":
        unitType = " S";
        break;
      case "loads":
        unitType = " LDS";
        break;
      case "pieces":
        unitType = " PCS";
        break;
      case "kgs":
        unitType = " KGS";
        break;
    }
    return unitType;
  };
  return (
    <p className="crop_name text-left">
      {(qty == 0 ? "" : getCurrencyNumberWithOneDigit(qty)) +
        (qtyUnit.toLowerCase() == "loads" ||
        qtyUnit.toLowerCase() == "pieces" ||
        qtyUnit.toLowerCase() == "kgs" ||
        qty == 0
          ? " "
          : getCropUnit(qtyUnit))}
      {qty == 0 || qty == null
        ? " "
        : weight == 0 || weight == null
          ? " "
          : " | "}
      {getCurrencyNumberWithOneDigit(weight) +
        (qtyUnit.toLowerCase() == "loads" ||
        qtyUnit.toLowerCase() == "pieces" ||
        qtyUnit.toLowerCase() == "kgs"
          ? getCropUnit(qtyUnit)
          : weight == 0 || weight == null
            ? ""
            : unittype == "QUINTAL"
              ? " QUINTAL"
              : unittype == "MT/TON"
                ? " MT/TON"
                : " KGS")}
      <span className="text-red-500">
        {wastage != "0"
          ? wastage != null
            ? " - " +
              getCurrencyNumberForWastage(wastage) +
              (qtyUnit != null && qtyUnit.toLowerCase() == "pieces"
                ? getCropUnit(qtyUnit)
                : qtyUnit != null && qtyUnit.toLowerCase() == "loads"
                  ? ""
                  : rateType == "RATE_PER_KG" ||
                      rateType == "RATE_PER_MANN" ||
                      rateType == "RATE_PER_QUINTAL" ||
                      rateType == "RATE_PER_MTORTON"
                    ? " KGS"
                    : getCropUnit(qtyUnit))
            : ""
          : ""}
      </span>
    </p>
  );
}
export function getTradeStatus(
  status,
  paidAmt,
  arlTime,
  pattiAmt,
  totalPayable,
) {
  let tradeStatus = status;
  if (status == "PENDING") {
    tradeStatus = "Approval Pending";
  }
  if (status == "ACCEPTED") {
    tradeStatus = "Trade Accepted";
  }
  if (
    status == "ARL_CONFIRMED" ||
    (arlTime != "" && pattiAmt == 0 && status != "PMT_PENDING")
  ) {
    tradeStatus = "Arrival Confirmed";
  }
  if (status == "PATTI_FINALIZED") {
    tradeStatus = "Patti Finalized";
    if (status == "PMT_COMPLETED" || paidAmt == totalPayable) {
      tradeStatus = "Payment Completed";
    } else if (paidAmt < totalPayable) {
      tradeStatus = "Payment Pending";
    } else {
      tradeStatus = "Patti Finalized";
    }
  }
  if (
    (status == "PMT_PENDING" || status == "PAYMENT") &&
    paidAmt > 0 &&
    totalPayable != 0
  ) {
    tradeStatus = "Payment Pending";
  }
  if (status == "PMT_COMPLETED") {
    tradeStatus = "Payment Completed";
  }
  if (status == "CANCEL") {
    tradeStatus = "Cancelled";
  }
  if (status == "CLOSED") {
    tradeStatus = "Trade Closed";
  }
  if (status == "REJECTED") {
    tradeStatus = "REJECTED";
  }
  return tradeStatus;
}
export const getTradeStatusDisplayTime = ({
  status = "",
  tradeCreateTime = "",
  tradeAcceptedTime = "",
  arrivalTime = "",
  paidAmt = 0,
  totalPayable = 0,
  tradeClosedTime = "",
}) => {
  if (status === "PENDING") {
    return {
      lable: "Trade Created on: ",
      time: moment(tradeCreateTime).format("DD-MMM-YYYY hh:mm a"),
      icon: acceptPendingIcon,
      icon2: penIcon,
    };
  } else if (status === "ACCEPTED") {
    return {
      lable: tradeAcceptedTime ? "Accepted on: " : "",
      time: tradeAcceptedTime
        ? moment(tradeAcceptedTime).format("DD-MMM-YYYY")
        : "",
      icon: tradeAcceptedIcon,
      icon2: "",
    };
  } else if (status === "ARL_INTIMATED") {
    return {
      lable: " ",
      time: "",
      icon: arrivalConfirmedIcon,
      icon2: "",
    };
  } else if (status === "ARL_CONFIRMED") {
    return {
      lable: "Arrived on: ",
      time: moment(arrivalTime).format("DD-MMM-YYYY | hh:mm a"),
      icon: arrivalConfirmedIcon,
      icon2: "",
    };
  } else if (status === "GRN_PENDING") {
    return {
      lable: " ",
      time: "",
      icon: acceptPendingIcon,
      icon2: "",
    };
  } else if (status === "GRN_CONFIRMED") {
    return {
      lable: " ",
      time: "",
      icon: arrivalConfirmedIcon,
      icon2: "",
    };
  } else if (status === "PATTI_FINALIZED") {
    //tradeStatus = "Patti Finalized";
    // if (paidAmt >= totalPayable) {
    //   // tradeStatus = "Payment Completed";
    //   return {
    //     lable: "",
    //     time: "",
    //     icon: paymentCompletedIcon,
    //     icon2: "",
    //   };
    // } else if (paidAmt < totalPayable) {
    //   //tradeStatus = "Payment Pending";
    //   return {
    //     lable: "",
    //     time: "",
    //     icon: tradeAcceptedIcon,
    //     icon2: penIcon,
    //   };
    // } else {
    // tradeStatus = "Patti Finalized";
    return {
      lable: "",
      time: "",
      icon: pattiIcon,
      icon2: "",
    };
    // }
  } else if (status === "PMT_PENDING") {
    return {
      lable: "",
      time: "",
      icon: paymentPending,
      icon2: penIcon,
    };
  } else if (status === "PMT_COMPLETED") {
    return {
      lable: "",
      time: "",
      icon: paymentCompleted,
      icon2: "",
    };
  } else if (status === "CANCEL" || status === "CANCELLED") {
    return {
      lable: "",
      time: "",
      icon: cancel_trade,
      icon2: "",
    };
  } else if (status === "CLOSED") {
    return {
      lable: tradeClosedTime ? "Closed on " : "",
      time: tradeClosedTime
        ? moment(tradeClosedTime).format("DD-MMM-YYYY")
        : "",
      icon: closed,
      icon2: "",
    };
  } else if (status === "DISPATCH_PENDING") {
    return {
      lable: "",
      time: "",
      icon: acceptPendingIcon,
      icon2: penIcon,
    };
  } else if (status === "DISPATCH_CONFIRMED") {
    return {
      lable: "",
      time: "",
      icon2: "",
      icon: tradeAcceptedIcon,
    };
  } else if (status === "CONFIRM_PENDING") {
    return {
      lable: "",
      time: "",
      icon2: "",
      icon2: penIcon,
      icon: acceptPendingIcon,
    };
  } else if (status === "PATTI_PENDING") {
    return {
      lable: "",
      time: "",
      icon: paymentPending,
      icon2: penIcon,
    };
  } else {
    return {
      lable: "",
      time: "",
      icon: "",
      icon2: "",
    };
  }
};
export const getAccountStatusDisplayIcon = ({
  status = "",
  fromTrader = false,
}) => {
  if (status === "ACTIVE" && !fromTrader) {
    return {
      icon: tickmark,
      color: "color-primary",
      label: "KYC Approved",
    };
  } else if (status === "ACTIVE" && fromTrader) {
    return {
      icon: approve,
      color: "color-primary",
      label: "Active",
    };
  } else if (status === "HOLD") {
    return {
      icon: hold,
      color: "color-orange",
      label: "Hold",
    };
  } else if (status === "REJECTED") {
    return {
      icon: reject,
      color: "color-red",
      label: "Rejected",
    };
  } else if (status === "BLOCKED") {
    return {
      icon: blocked,
      color: "color-red",
      label: "Blocked",
    };
  } else if (status === "PENDING") {
    return {
      icon: timer,
      color: "color-orange",
      label: "Pending",
    };
  } else if (status === "APPROVED") {
    return {
      icon: approved,
      color: "color-primary",
      label: "Approved",
    };
  } else if (status === "DISBURSED") {
    return {
      icon: disburse,
      color: "color-primary",
      label: "Disbursed",
    };
  } else if (status === "UNDER REVIEW") {
    return {
      icon: timer,
      color: "color-orange",
      label: "Under Review",
    };
  } else if (status === "CLOSED") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Closed",
    };
  } else if (status === "EXPIRED") {
    return {
      icon: rejectExclamatory,
      color: "color-red",
      label: "Expired",
    };
  } else if (status === "REVALIDATE") {
    return {
      icon: timer,
      color: "color-orange",
      label: "Revalidate",
    };
  } else if (status === "INACTIVE") {
    return {
      icon: timer,
      color: "color-orange",
      label: "InActive",
    };
  } else if (status === "ESIGN_PENDING") {
    return {
      icon: timer,
      color: "color-orange",
      label: "E-sign Pending",
    };
  } else if (status === "KYC_PENDING") {
    return {
      icon: loan_kyc_pend,
      color: "loan_kyc_pending_color",
      label: "KYC Pending",
    };
  } else {
    return {
      color: "",
      icon: "",
      label: "",
    };
  }
};

export const getBenificiaryStatusDisplayIcon = ({ status = "" }) => {
  if (status === "ACTIVE") {
    return {
      icon: tickmark,
      color: "color-primary",
      label: "Active",
    };
  } else if (status === "ACTIVE") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Active",
    };
  } else if (status === "HOLD") {
    return {
      icon: hold,
      color: "color-orange",
      label: "Hold",
    };
  } else if (status === "REJECTED") {
    return {
      icon: reject,
      color: "color-red",
      label: "Rejected",
    };
  } else if (status === "BLOCKED") {
    return {
      icon: blocked,
      color: "color-red",
      label: "Blocked",
    };
  } else if (status === "PENDING") {
    return {
      icon: timer,
      color: "color-orange",
      label: "Pending",
    };
  } else if (status === "APPROVED") {
    return {
      icon: approved,
      color: "color-primary",
      label: "Approved",
    };
  } else if (status === "DISBURSED") {
    return {
      icon: disburse,
      color: "color-primary",
      label: "Disbursed",
    };
  } else if (status === "UNDER REVIEW") {
    return {
      icon: timer,
      color: "color-orange",
      label: "Under Review",
    };
  } else if (status === "CLOSED") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Closed",
    };
  } else if (status === "EXPIRED") {
    return {
      icon: rejectExclamatory,
      color: "color-red",
      label: "Expired",
    };
  } else {
    return {
      color: "",
      icon: "",
      label: "",
    };
  }
};

export const getFrequencyText = (value) => {
  if (value === "WEEKLY") {
    return "Weekly";
  } else if (value === "BIWEEKLY") {
    return "Bi-Weekly";
  } else if (value === "MONTHLY") {
    return "Monthly";
  }
  return value;
};

export const getTradesStatusDisplayIcon = ({ status = "" }) => {
  if (status === "DRAFTED") {
    return {
      icon: acceptPend,
      color: "color-orange",
      label: "Drafted",
    };
  } else if (status === "PENDING") {
    return {
      icon: acceptPend,
      color: "color-orange",
      label: "Trade Acceptance Pending",
    };
  } else if (status === "ACCEPTED") {
    return {
      icon: tradeaccepted,
      color: "color-primary",
      label: "Trade Accepted",
    };
  } else if (status === "GRN_PENDING") {
    return {
      icon: acceptPend,
      color: "color-orange",
      label: "GRN Pending",
    };
  } else if (status === "GRN_CONFIRMED") {
    return {
      icon: arlConf,
      color: "color-primary",
      label: "GRN Confirmed",
    };
  } else if (status === "ARL_INTIMATED") {
    return {
      icon: arlConf,
      color: "color-primary",
      label: "Arrival Intimated",
    };
  } else if (status === "ARL_CONFIRMED") {
    return {
      icon: arlConf,
      color: "color-primary",
      label: "Arrival Confirmed",
    };
  } else if (status === "PATTI_FINALIZED") {
    return {
      icon: pattiFinal,
      color: "color-primary",
      label: "Patti Finalized",
    };
  } else if (status === "PMT_PENDING") {
    return {
      icon: pmtPend,
      color: "color-primary",
      label: "Payment Pending",
    };
  } else if (status === "PMT_COMPLETED") {
    return {
      icon: pmtCompl,
      color: "color-primary",
      label: "Payment Completed",
    };
  } else if (status === "CANCELLED" || status === "CANCEL") {
    return {
      icon: cancel_trade,
      color: "color-red",
      label: "Trade Cancelled",
    };
  } else if (status === "CLOSED") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Trade Closed",
    };
  } else if (status === "EXPIRED") {
    return {
      icon: cancel_trade,
      color: "color-red",
      label: "Cancelled",
    };
  } else if (status === "DISPATCH_PENDING") {
    return {
      icon: acceptPend,
      color: "color-orange",
      label: "Dispatch Pending",
    };
  } else if (status === "DISPATCH_CONFIRMED") {
    return {
      icon: tradeaccepted,
      color: "color-primary",
      label: "Dispatch Confirmed",
    };
  } else if (status === "CONFIRM_PENDING") {
    return {
      icon: acceptPend,
      color: "color-orange",
      label: "Trade Confirmation Pending",
    };
  } else if (status === "PATTI_PENDING") {
    return {
      icon: pmtPend,
      color: "color-primary",
      label: "Patti Pending",
    };
  } else {
    return {
      color: "",
      icon: "",
      label: "",
    };
  }
};

export function getCropUnitFull(unit, qty) {
  const unitTypes = {
    CRATES: "Crates",
    BOXES: "Boxes",
    BAGS: "Bags",
    SACS: "Sacs",
    LOADS: "Loads",
    PIECES: "Pieces",
  };
  const abbreviation = unitTypes[unit.toUpperCase()] || "";
  return qty ? qty.toFixed(1) + abbreviation : "";
}
export function toCamelCaseWord(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function maskAccountNumber(str) {
  let value = str;
  if (value.length > 4) {
    let count = value.length - 4;
    let accNum = "";
    for (let i = 0; i < count; i++) {
      accNum += "X";
    }
    accNum += str.substring(str.length - 4, str.length);
    value = accNum;
  }
  return value;
}

export function getAccLastFourDigits(str) {
  let value = str;
  if (value.length > 4) {
    let accNum = "X";
    accNum += str.substring(str.length - 4, str.length);
    value = accNum;
  }
  return value;
}

export function getPaymentTypeName(value) {
  let text = "";
  switch (value) {
    case "TRANSPORTATION":
      text = "Transportation";
      break;
    case "ADVANCE":
      text = "Advance";
      break;
    case "PARTIAL_PAYMENT":
      text = "Partial Payment";
      break;
    case "FINAL_PAYMENT":
      text = "Final Payment";
      break;
    case "FULL_PAYMENT":
      text = "Full Payment";
      break;
  }
  return text;
}

export function getLoanTypeName(value) {
  let text = "";
  switch (value) {
    case "TRADE ADVANCE":
      text = "Trade Advance";
      break;
    case "WORKING CAPITAL":
      text = "Working Capital";
      break;
    case "TRADE FINANCE":
      text = "Trade Finance";
      break;
    case "FARMER ADVANCE":
      text = "Farmer Advance";
      break;
  }
  return text;
}

export function getLoanPartyType(value) {
  let text = "";
  switch (value) {
    case "FARMER":
      text = "Farmer ID";
      break;
    case "OWNER":
      text = "Owner ID";
      break;
  }
  return text;
}

export function numberPrecision(number, digits = 2) {
  return parseFloat(number.toFixed(digits));
}

export const validateTruckNumber = (number) => {
  const truckNumberRegex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{0,2}[0-9]{4}$/;
  return truckNumberRegex.test(number.toUpperCase());
};

export const validateMobileNumber = (number) => {
  const mobileRegex = /^[6-9]\d{9}$/;
  return mobileRegex.test(number);
};

// export function numberPrecision(number, digits = 2) {
//   const num = Number(number);
//   if (isNaN(num)) return 0;
//   return parseFloat(num.toFixed(digits));
// }
export const getDemandStatusDisplayIcon = ({ status = "" }) => {
  const statusValue = (status || "").toUpperCase().trim().replace(/\s+/g, "");
  if (statusValue === "REVIEWPENDING") {
    return {
      icon: acceptPend,
      color: "color-orange",
      label: "Review Pending ",
    };
  } else if (statusValue === "PROPOSALACCEPTED") {
    return {
      icon: tradeaccepted,
      color: "color-primary",
      label: "Proposal Accepted",
    };
  } else if (statusValue === "CONFIRMED") {
    return {
      icon: tradeaccepted,
      color: "color-primary",
      label: "Trade Confirmed",
    };
  } else if (statusValue === "DEMANDPOSTED") {
    return {
      icon: tradeaccepted,
      color: "color-primary",
      label: "Demand Posted",
    };
  } else if (statusValue === "FULFILLED") {
    return {
      icon: tradeaccepted,
      color: "color-primary",
      label: "Fulfilled",
    };
  } else if (statusValue === "EXPIRED") {
    return {
      icon: cancel_trade,
      color: "color-red",
      label: "Expired",
    };
  } else {
    return {
      color: "",
      icon: "",
      label: "",
    };
  }
};

export const enableExcessPayment = (pmtType) => {
  return pmtType == "FINAL_PAYMENT" || pmtType == "FULL_PAYMENT";
};
export function getLoanTypeNameToEnum(value) {
  let text = "";
  switch (value) {
    case "TRADE ADVANCE":
      text = "TRADE_ADVANCE";
      break;
    case "WORKING CAPITAL":
      text = "WORKING_CAPITAL";
      break;
    case "TRADE FINANCE":
      text = "TRADE_FINANCE";
      break;
  }
  return text;
}
export function getLoanType(value) {
  if (value === 1) {
    return "Farmer Advance";
  } else if (value === 2) {
    return "Working Capital";
  } else if (value === 3) {
    return "Trade Advance";
  }
  return value;
}
export const getLoanStatusDisplayIcon = ({ status = "" }) => {
  if (status === "ACTIVE") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Active",
    };
  } else if (status === "FULLY PAID") {
    return {
      icon: fullyPaid,
      color: "color-blue",
      label: "Repaid",
    };
  } else if (status === "OVER DUE") {
    return {
      icon: overDue,
      color: "color-red",
      label: "Overdue",
    };
  } else if (status === "CLOSED") {
    return {
      icon: close,
      color: "color-red",
      label: "Closed",
    };
  } else {
    return {
      color: "",
      icon: "",
      label: "",
    };
  }
};
export const getMarketStatusDisplayIcon = ({ status = "" }) => {
  if (status === "ACTIVE") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Active",
    };
  } else if (status === "INACTIVE") {
    return {
      icon: exclamatory,
      color: "color-orange",
      label: "Inactive",
    };
  } else if (status === "REJECTED") {
    return {
      icon: reject,
      color: "color-red",
      label: "Rejected",
    };
  } else if (status === "UNDER REVIEW") {
    return {
      icon: reviewYellow,
      color: "color-yellow",
      label: "Under Review",
    };
  } else {
    return {
      color: "",
      icon: "",
      label: "",
    };
  }
};
export function getLatestClosedDate(date1, date2) {
  if (!date1 && !date2) return null;

  if (!date1) return moment(date2).format("DD-MMM-YYYY");
  if (!date2) return moment(date1).format("DD-MMM-YYYY");

  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const latest = d1 > d2 ? date1 : date2;
  return moment(latest).format("DD-MMM-YYYY");
}

export function getWalletStatus({ status = "" }) {
  if (status === "ACTIVE") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Active",
    };
  } else if (status === "INITIATED") {
    return {
      icon: timer,
      color: "color-orange",
      label: "Initiated",
    };
  } else if (status === "CREATED") {
    return {
      icon: approve,
      color: "color-primary",
      label: "Created",
    };
  } else {
    return {
      color: "",
      icon: "",
      label: "",
    };
  }
}

export function parseNumber(value) {
  if (value != null) {
    return Number(value);
  }
  return "";
}

export const paymentTypes = [
  { label: "Transportation", value: "TRANSPORTATION" },
  { label: "Advance", value: "ADVANCE" },
  { label: "Partial Payment", value: "PARTIAL_PAYMENT" },
  { label: "Full Payment", value: "FULL_PAYMENT" },
  { label: "Final Payment", value: "FINAL_PAYMENT" },
];

export function getPaymentLabel(value) {
  return paymentTypes.find((option) => option.value === value)?.label || "-";
}

export function getProducts(value) {
  if (value === "FARMER ADVANCE") {
    return "Farmer Advance";
  } else if (value === "WORKING CAPITAL") {
    return "Working Capital";
  } else if (value === "TRADE FINANCE") {
    return "Trade Finance";
  }
  return value;
}

export function formatInCrores(value) {
  const amount = Number(value || 0);
  return `${(amount / 10000000).toFixed(2)}`;
}

export const getCollectionStatusDisplayIcon = ({ status = "" }) => {
  if (status === "SUCCESS") {
    return {
      color: "color-primary",
      label: "Success",
    };
  } else if (status === "BEN_FAILURE") {
    return {
      color: "color-red",
      label: "Validation Failed",
    };
  } else if (status === "BEN_SUCCESS") {
    return {
      color: "color-orange",
      label: "Validated",
    };
  } else {
    return {
      color: "",
      label: "",
    };
  }
};

export const getCollectionStatus = (status) => {
  if (status === "SUCCESS") {
    return "Success";
  } else if (status === "BEN_FAILURE") {
    return "Validation Failed";
  } else if (status === "BEN_SUCCESS") {
    return "Validated";
  } else {
    return "";
  }
};

export const getCategory = (value) => {
  if (value === "FIN") {
    return "Financial";
  } else if (value === "TXN") {
    return "Transaction";
  } else if (value === "AMID") {
    return "AMID";
  } else if (value === "CREDIT") {
    return "Credit Score";
  }
  return "";
};

export const formatExcelDate = (date) => {
  if (date === null || date === undefined || date === "") return null;

  const d = new Date(date);
  if (isNaN(d.getTime())) return null;

  const year = d.getFullYear();

  if (year < 2000) return null;

  return {
    v:
      (Date.UTC(year, d.getMonth(), d.getDate()) - Date.UTC(1899, 11, 30)) /
      (1000 * 60 * 60 * 24),
    t: "n",
    z: "dd-mm-yyyy",
  };
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "";

  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

export default {
  getText,
  getPartnerType,
  getUnitVal,
  getQuantityUnit,
  colorAdjustBg,
  formatInvLedger,
  qtyValues,
  getCropUnitFull,
  toCamelCaseWord,
  maskAccountNumber,
  getAccLastFourDigits,
  getLoanTypeName,
  getLoanPartyType,
  getDemandStatusDisplayIcon,
  getLoanTypeNameToEnum,
  getBenificiaryStatusDisplayIcon,
  getFrequencyText,
  getLoanType,
  getLoanStatusDisplayIcon,
  getLatestClosedDate,
  getWalletStatus,
  getPaymentLabel,
  getProducts,
  formatInCrores,
  getCollectionStatusDisplayIcon,
  getCollectionStatus,
  getCategory,
  formatExcelDate,
  formatDate,
};
